import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ISesionState {
	key: string;
	nombreSesion?: string;
	objetivoSesion?: string;
	evidencia?: string;
	isOpen?: boolean;
	tipo?: { value: string; label: string; disabled?: boolean } | undefined;
}

export interface IEtapaState {
	key: string;
	nombre?: string;
	isOpen?: boolean;
}

export interface IPlanificacionEditState {
	sesiones?: ISesionState[];
	etapas?: IEtapaState[];
}

const initialState: IPlanificacionEditState = null as unknown as IPlanificacionEditState;

const planificacionEditStateSlice = createSlice({
	name: 'planificacionEditState',
	initialState,
	reducers: {
		addSesionDataPlan: (state, action: PayloadAction<ISesionState>) => {
			const sesiones = state?.sesiones || [];
			if (!sesiones.some((sesion) => sesion.key === action.payload.key)) {
				return { ...state, sesiones: [...sesiones, action.payload] };
			}
			return state;
		},
		updateSesionDataPlan: (state, action: PayloadAction<ISesionState>) => {
			const sesiones = state?.sesiones || [];
			const updatedSesiones = sesiones?.map((sesion) => {
				if (sesion.key === action.payload.key) {
					return action.payload;
				}
				return sesion;
			});
			return { ...state, sesiones: updatedSesiones };
		},
		removeSesionDataPlan: (state, action: PayloadAction<string>) => {
			const sesiones = state?.sesiones || [];
			const updatedSesiones = sesiones?.filter((sesion) => sesion.key !== action.payload);
			return { ...state, sesiones: updatedSesiones };
		},
		addEtapaDataPlan: (state, action: PayloadAction<IEtapaState>) => {
			const etapas = state?.etapas || [];
			if (!etapas.some((etapa) => etapa.key === action.payload.key)) {
				return { ...state, etapas: [...etapas, action.payload] };
			}
			return state;
		},
		updateEtapaDataPlan: (state, action: PayloadAction<IEtapaState>) => {
			const etapas = state?.etapas || [];

			const updatedEtapas = etapas?.map((etapa) => {
				if (etapa.key === action.payload.key) {
					return action.payload;
				}
				return etapa;
			});
			return { ...state, etapas: updatedEtapas };
		},
		removeEtapaDataPlan: (state, action: PayloadAction<string>) => {
			const etapas = state?.etapas || [];
			const updatedEtapas = etapas?.filter((etapa) => etapa.key !== action.payload);
			return { ...state, etapas: updatedEtapas };
		},
		resetPlanificacionEditState: () => {
			return initialState;
		}
	}
});

export const {
	addSesionDataPlan,
	updateSesionDataPlan,
	addEtapaDataPlan,
	removeSesionDataPlan,
	updateEtapaDataPlan,
	removeEtapaDataPlan,
	resetPlanificacionEditState
} = planificacionEditStateSlice.actions;

export default planificacionEditStateSlice.reducer;
